import { constants } from "@newsela/angelou";

const { colors } = constants;

export const errorTextCss = {
  color: colors.status.danger[700],
  display: "inline-block",
  "&&&&": {
    margin: "18px 10px 12px 0",
  },
};

export const errorButtonCss = {
  color: colors.ui.core[700],
};

export const errorButtonWrapperCss = {
  display: "inline-block",
  width: "fit-content",
};
